import {StockSearchPillCollectionBase} from "@/classes/stock/StockSearchPillCollectionBase";

export default class BrowsePicksSearchPillCollection extends StockSearchPillCollectionBase {
    constructor() {
        super();

        this.jobRef = {
            enabled: true,
            history: []
        };

        this.warehouseRef = {
            enabled: true,
            history: []
        };

        this.releaseDateFrom = {
            enabled: true,
        };

        this.releaseDateTo = {
            enabled: true,
        };

        this.customerRef = {
            enabled: true,
            history: []
        };

        this.soNumber = {
            enabled: true,
            history: []
        };

        this.deliverTo = {
            enabled: true,
            history: []
        };

        this.releasedBy = {
            enabled: true,
            history: []
        };
    }

}
